import React from 'react';
import { useApiHolder } from '@backstage/frontend-plugin-api';
import { Administration, rbacApiRef } from '@backstage-community/plugin-rbac';

/**
 * Renders the RBAC <Administration /> sidebar entry only when the RBAC plugin
 * API is registered; renders nothing otherwise.
 *
 * The RBAC plugin is wired in Phase 5d; before that its apiRef is absent from
 * the registry. The Administration component calls useApi() internally, which
 * throws NotImplementedError when the API is absent, triggering the rspack
 * error overlay in dev mode and masking page content (false E2E failures).
 *
 * useApiHolder().get() returns undefined instead of throwing, so the overlay
 * is never triggered. This guard is harmless once the API is registered and
 * may stay in place or be removed after Phase 5d.
 */
export const SafeAdministration = (): React.ReactElement | null => {
  const apiHolder = useApiHolder();
  const api = apiHolder.get(rbacApiRef);

  if (!api) {
    return null;
  }

  return <Administration />;
};
